export const extractOrdersFromApiResponse = (data: any) => {
  let ordensData = [];
  let totalItems = 0;
  
  // Verificar a estrutura da resposta da API
  if (data?.data?.itens && Array.isArray(data.data.itens)) {
    ordensData = data.data.itens;
    totalItems = data.data.total || data.data.totalItems || ordensData.length;
  } else if (data?.itens && Array.isArray(data.itens)) {
    ordensData = data.itens;
    totalItems = data.total || data.totalItems || ordensData.length;
  } else if (data?.data && Array.isArray(data.data)) {
    ordensData = data.data;
    totalItems = data.total || data.totalItems || ordensData.length;
  } else if (Array.isArray(data)) {
    ordensData = data;
    totalItems = ordensData.length;
  } else {
    // Tentativas adicionais para encontrar os dados
    if (typeof data === 'object' && data !== null) {
      const possibleArrays = Object.values(data).filter(value => Array.isArray(value));
      if (possibleArrays.length > 0) {
        ordensData = possibleArrays[0] as any[];
        totalItems = ordensData.length;
      }
    }
  }
  
  if (!ordensData || ordensData.length === 0) {
    return { ordensData: [], totalItems: 0 };
  }
  
  return { ordensData, totalItems };
};
